<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="page-table-header">
          <PageHeader :page-title="'Partners bank details'">
            <template v-slot:buttons>
              <b-button
                class="button title-container__controls-item"
                :variant="isShowFilter ? 'secondary' : 'info'"
                @click="toggleShowFilter"
              >
                <span class="material-icons icon-image-preview">
                  tune
                </span>
                Filters
              </b-button>
              <b-button
                v-if="$can(permissions.CreateFinancesClientBankDetails)"
                class="button"
                variant="success"
                @click.prevent="showCreateModal"
                :disabled="isDataPageLoading"
              >
                Create
              </b-button>
            </template>
          </PageHeader>

          <Filters
            v-show="isShowFilter"
            textButtonSubmit="Filter"
            :data="getFilters"
            :isLoading="isDataPageLoading"
            @submit="setFilterBankDetails"
          />

          <TableForPage
            ref="table"
            :tableData="getBankDetailsTableData"
            :fields="getTableFields"
            v-if="getBankDetailsTableData.length"
            :perPage="getBankDetails.per_page"
            :currentPage="getBankDetails.current_page"
            :totalRows="getBankDetails.total"
            :tableRowModalFields="tableRowModal.fields"
            :isEdit="$can(permissions.UpdateAllFinancesPartnerBankDetails)"
            :isRemove="$can(permissions.DeleteFinancesPartnerBankDetails)"
            isShowView
            isServerRender
            noLocalSorting
            @edit="showEditModal"
            @remove="removeBankDetails"
            @update="updateBankDetails"
          />
        </div>
      </div>
    </div>

    <b-modal
      size="lg"
      hide-footer
      v-model="createModal.show"
      class="modal"
      @show="resetCreateModalForm"
    >
      <template v-slot:modal-header="{ cancel }">
        <h5 class="modal-title">{{createModal.title}}</h5>
        <button
          type="button"
          aria-label="Close"
          class="close"
          @click.prevent="cancel"
        >
          <span class="material-icons">
            close
          </span>
        </button>
      </template>
      <FormGenerator
        :data="createModal.form"
        :isLoading="isDataPageLoading"
        @submit="createBankDetails"
        :showReset="false"
        :textButtonSubmit="createModal.submitButtonText"
      >
        <template v-slot:companyName="slotProps">
          <b-form-group v-if="isBusinessEntityCompany(slotProps.fields.business_entity_type)">
            <label>{{slotProps.data.label}}</label>
            <b-form-input
              v-model="slotProps.data.value"
              :required="slotProps.data.required"
              :placeholder="slotProps.data.placeholder"
            />
          </b-form-group>
        </template>
        <template v-slot:companyNameNational="slotProps">
          <b-form-group v-if="isBusinessEntityCompany(slotProps.fields.business_entity_type)">
            <label>{{slotProps.data.label}}</label>
            <b-form-input
              v-model="slotProps.data.value"
              :required="slotProps.data.required"
              :placeholder="slotProps.data.placeholder"
            />
          </b-form-group>
        </template>
      </FormGenerator>
    </b-modal>
    <b-modal
      size="lg"
      hide-footer
      v-model="editModal.show"
      class="modal"
    >
      <template v-slot:modal-header="{ cancel }">
        <h5 class="modal-title">{{editModal.title}}</h5>
        <button
          type="button"
          aria-label="Close"
          class="close"
          @click.prevent="cancel"
        >
          <span class="material-icons">
            close
          </span>
        </button>
      </template>
      <FormGenerator
        :data="editModal.form"
        @submit="editBankDetails"
        :showReset="false"
        :textButtonSubmit="editModal.submitButtonText"
      >
        <template v-slot:companyName="slotProps">
          <b-form-group v-if="isBusinessEntityCompany(slotProps.fields.business_entity_type)">
            <label>{{slotProps.data.label}}</label>
            <b-form-input
              v-model="slotProps.data.value"
              :required="slotProps.data.required"
              :placeholder="slotProps.data.placeholder"
            />
          </b-form-group>
        </template>
        <template v-slot:companyNameNational="slotProps">
          <b-form-group v-if="isBusinessEntityCompany(slotProps.fields.business_entity_type)">
            <label>{{slotProps.data.label}}</label>
            <b-form-input
              v-model="slotProps.data.value"
              :required="slotProps.data.required"
              :placeholder="slotProps.data.placeholder"
            />
          </b-form-group>
        </template>
      </FormGenerator>
    </b-modal>
  </div>
</template>

<script>
import PageHeader from '@components/PageHeader'
import Filters from '@components/Filter/Filter'
import FormGenerator from '@components/FormGenerator'
import TableForPage from '@tables/TableForPage'
import BankDetailsMixin from '../mixins/BankDetailsMixin'
import { mapGetters } from 'vuex'

export default {
  name: 'FinanceBankDetailsPartners',
  components: {
    PageHeader,
    Filters,
    TableForPage,
    FormGenerator
  },
  mixins: [BankDetailsMixin],
  data () {
    return {
      modalTitle: 'Partners Bank Details',
      ownershipId: 3,
      currentFields: [
        'name',
        'partner.company_name',
        'currency.name',
        'country.name',
        'business_entity_type.type',
        'first_name',
        'last_name',
        'company_name',
        'actions'
      ]
    }
  },
  computed: {
    ...mapGetters({
      getAllPartners: 'partners/getAllPartners'
    }),
    getFilters () {
      const currentFilers = (({
        partnerId,
        currencyId,
        country,
        businessEntityTypeId,
        firstName,
        lastName,
        companyName
      }) => ({
        partnerId,
        currencyId,
        country,
        businessEntityTypeId,
        firstName,
        lastName,
        companyName
      }))(this.filters)

      return currentFilers
    },
    formMock () {
      return {
        'id': {
          name: 'id'
        },
        'partner': {
          type: 'select',
          name: 'partner_id',
          label: 'Partners*',
          selectLabel: 'company_name',
          valueField: 'id',
          options: [],
          value: null,
          validation: [
            { name: 'required' }
          ],
          class: 'col-12'
        },
        ...this.mainFormMock
      }
    }
  },
  methods: {
    fetchAllData () {
      this.fetchBankDetails()
      Promise.all([
        this.fetchAllPartners(),
        this.fetchBusinessEntityTypes(),
        this.fetchCountries(),
        this.fetchCurrencies()
      ])
        .then(values => {
          this.setAllOptionsFilter()
        })
    },
    setAllOptionsFilter () {
      this.createModal.form.partner.options = this.getAllPartners
      this.createModal.form.business_entity_type.options = this.getBusinessEntityTypes
      this.createModal.form.country.options = this.getCountries
      this.createModal.form.currency.options = this.getCurrencies

      this.editModal.form.partner.options = this.getAllPartners
      this.editModal.form.business_entity_type.options = this.getBusinessEntityTypes
      this.editModal.form.country.options = this.getCountries
      this.editModal.form.currency.options = this.getCurrencies

      this.filters.partnerId.options = this.getAllPartners
      this.filters.businessEntityTypeId.options = this.getBusinessEntityTypes
      this.filters.currencyId.options = this.getCurrencies
      this.filters.country.options = this.getCountries

      this.isDataPageLoading = false
    }
  }
}
</script>

<style>

</style>
